import swal from "sweetalert";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

const internalServerError = (text, history) => {
  swal({
    title: "Internal Server Error!",
    icon: "warning",
    text,
  }).then(() => {
    localStorage.removeItem("id_token");
    localStorage.removeItem(LOCALSTORAGEKEY.USER_ID);
    history.push("/admin/auth/login");
  });
};

export default internalServerError;
